(function ($) {
    $(document).ready(function () {

//         var elms = document.getElementsByClassName( 'splide-slider-clients' );
// // autoplay the loop
// for ( var i = 0; i < elms.length; i++ ) {
//     var splide = new Splide( elms[ i ], {
//         type    : 'loop',
//         autoplay: true,
//         gap: '20px',
//         reducedMotion: {
//             interval: 3000,
//             speed: 800,
//             autoplay: "play"
//           },
        
//         pagination: false,
//         arrows: false,
//         perMove: 1,
//         fixedWidth: '24%',
//         padding: '4rem'
        
    


// } );

// splide.mount();


// }
    
    }); 
})(jQuery);
